import _ from 'lodash';

/*
Input is an array of hashes like this:
[
  {
    document: <FileList file1, file2>
  },
  {
    document: <FileList file3, file4>
  }
]

Output is an array of hashes like this:
[
  {
    document: file1
  },
  {
    document: file2
  },
  {
    document: file3
  },
  {
    document: file4
  }
]
*/

export default function transformFileList(arrayOfDocumentHashes, key = 'document') {
  // Map array of hashes to array of FileLists
  const arrayOfFileLists = _.compact(arrayOfDocumentHashes.map(documentHash => documentHash[key]));

  // Convert each FileList into an array of Files, resulting in an array of arrays.
  const arrayOfArrayOfFiles = arrayOfFileLists.map(fileList => _.map(fileList, file => file));

  // Flatten the array of arrays of files into a flat array of files
  const arrayOfFiles = _.flatten(arrayOfArrayOfFiles);

  // Map array of files to array of hashes with the file stored in the `document` key
  return arrayOfFiles.map(file => ({ [key]: file }));
}
